import {percent} from 'js/common/string_helper';

const EPSILON = 0.00001;

/**
 * Adapted from here: http://floating-point-gui.de/errors/comparison/
 * @export
 * @param {number} a
 * @param {number} b
 * @param {*} [epsilon=EPSILON]
 * @return {*}  {boolean}
 */
export function nearlyEqual(a, b, epsilon = EPSILON) {
    const absA = Math.abs(a);
    const absB = Math.abs(b);
    const diff = Math.abs(a - b);

    if (a == b) {
        // shortcut, handles infinities
        return true;
    } else if (a == 0 || b == 0 || diff < Number.MIN_VALUE) {
        // a or b is zero or both are extremely close to it
        // relative error is less meaningful here
        return diff < epsilon * Number.MIN_VALUE;
    } // use relative error
    return diff / (absA + absB) < epsilon;
}

export function calculateIntegerDiff(projected, actual) {
    const diff = Math.round(actual - projected);
    if (diff >= 0) {
        return `+${diff}`;
    }
    return diff;
}

export function calculatePercentageDiff(projected, actual) {
    const diff = actual - projected;
    const percentage = percent(diff / projected);
    if (diff >= 0) {
        return `+${percentage}`;
    }
    return percentage;
}

export function formatCurrency(number) {
    return number.toLocaleString(undefined, {
        style: 'currency',
        currency: 'USD'
    });
}



// WEBPACK FOOTER //
// ./common/math_helper.js